module.exports = __webpack_public_path__ + "static/8-24abbc3416ec25b144a96cb11b7cf5d7.png";